export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const NAME = process.env.REACT_APP_NAME
export const CURRENCY = process.env.REACT_APP_CURRENCY
export const TIME_FILTER_SUPPORT = false

